var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubsidized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0021 6.99789H16.0017",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99756 14.0008H6.99798",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99925 17.0021H5.49738C4.11609 17.0021 2.99634 15.8823 2.99634 14.501V6.49768C2.99634 5.83437 3.25984 5.19822 3.72888 4.72918C4.19791 4.26014 4.83406 3.99664 5.49738 3.99664H17.5024C18.8837 3.99664 20.0034 5.1164 20.0034 6.49768V9.99914",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0043 21.0038L19.8313 18.8318",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99925 17.0021H5.49738C4.11609 17.0021 2.99634 15.8823 2.99634 14.501V6.49768C2.99634 5.83437 3.25984 5.19822 3.72888 4.72918C4.19791 4.26014 4.83406 3.99664 5.49738 3.99664H17.5024C18.8837 3.99664 20.0034 5.1164 20.0034 6.49768V9.99914",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73132 12.2679C8.7546 11.2912 8.7546 9.70761 9.73132 8.73089C10.708 7.75417 12.2916 7.75417 13.2683 8.73089",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0022,
    cy: 16.0017,
    r: 4.00167,
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsidized);
export default __webpack_public_path__ + "static/media/subsidized.82be3149088849213a7511251487d30f.svg";
export { ForwardRef as ReactComponent };